import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SettingBuilder } from '../../models/builders/setting-builder';
import { Setting } from '../../models/setting';
import { ItemsPerPageBuilder } from '../../models/builders/items-per-page-builder';
import { VatBuilder } from '../../models/builders/vat.buildet';
import { ControlDocumentTransportOperatorBuilder } from '../../models/builders/control-document-transport-operator.builder';
import { ControlDocumentCarrierBuilder } from '../../models/builders/control-document-carrier.builder';

const getSettingBody = (setting: Setting) => ({
  value: setting.value
});

@Injectable()
export class SettingApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}settings`;
  }

  getSetting(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
     .pipe(
       map(SettingBuilder.fromJson)
     );
   }

  getSettings() {
    return this.httpClient.get(this.apiUrl).pipe(map(SettingBuilder.fromJsonList));
  }

  updateSetting(setting: Setting) {
    return this.httpClient.put(`${ this.apiUrl }/${ setting.hash }`, getSettingBody(setting));
  }

  getItemsPerPage() {
    return this.httpClient.get(`${ this.apiUrl }/items-per-page`).pipe(map(ItemsPerPageBuilder.fromJson));
  }

  getDefaultVat() {
    return this.httpClient.get(`${ this.apiUrl }/default-vat`).pipe(map(VatBuilder.fromJson));
  }

  getDefaultControlDocumentTransportOperator() {
    return this.httpClient.get(`${ this.apiUrl }/default-control-document-transport-operator`).pipe(
        map(ControlDocumentTransportOperatorBuilder.fromJson)
    );
  }

  getDefaultControlDocumentCarrier() {
    return this.httpClient.get(`${ this.apiUrl }/default-control-document-carrier`).pipe(
        map(ControlDocumentCarrierBuilder.fromJson)
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/api/setting-api.service.ts